// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__feML_","logo":"footer_logo___d_IO","hide":"footer_hide__P55C0"};